














































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import { User } from '@/domain/User'
import UsersService from '@/service/UsersService'
import DateUtils from '@/utils/DateUtils'

@Component({
  components: {
    DatePickerComponent,
  },
})
export default class DateAndUserPickerDialogComponent extends Vue {
  usersService = UsersService.instance
  dateUtils = DateUtils.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /* タイトル */
  @Prop({ default: "実施日入力" })
  title!: string

  /* 名前 */
  @Prop({ default: "実施日" })
  name!: string

  /* キー(呼び出し元に戻す) */
  @Prop({ default: "" })
  itemKey!: string

  /* 初期ユーザID */
  @Prop({ default: "" })
  default!: ""

  /* 職種コード */
  @Prop({ default: 1 })
  occupationCode!: number

  /** バリデーション */
  invalid = false

  /** 実施日 */
  date = this.dateUtils.getToday()

  /* 実施者 */
  userId = ""
  user = new User()

  /* 実施者リスト */
  users: User[] = []

  mounted() {
    this.usersService.findByOccupationCode(this.occupationCode)
      .then(x => {
        this.users = x
        this.reset()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.users = []
        this.reset()
      })
  }

  /**
   * 初期化
   */
  reset() {
    this.date = this.dateUtils.getToday()
    this.userId = this.default
    const user = this.users.find(x => x.userId === this.userId)
    if (user !== undefined) {
      this.user = user
    } else {
      this.user = new User()
      this.userId = ""
    }
  }

  /**
   * 実施者の変更
   */
  // eslint-disable-next-line
  onChangeUser(event: User) {
    this.user = event
  }

  /**
   * オートコンプリートフィルター
   */
  // eslint-disable-next-line
  usersFilter(item: User, queryText: string, itemText: string) {
    return item.userName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", [
      this.itemKey,
      this.date,
      this.user
    ])
    this.reset()
  }

}
